<template>
  <div class="loading">
    <img :src="require('images/voicemod-loader.gif')">
    {{ $t('logincheck.loading') }}
  </div>
</template>

<script>
import { ROUTER_PATHS } from '@/router/paths';
import * as Sentry from '@sentry/vue';

export default {
    props: {
        from: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            timeoutId: null,
            timeToUnblockLoading: 30000,
        };
    },
    mounted() {
        this.timeoutId = setTimeout(() => {
            Sentry.captureMessage(`Loading timeout after ${this.timeToUnblockLoading / 1000}s: ${this.from}`);
            this.$router.push(ROUTER_PATHS.ACCOUNT_ACTIVATED_ERROR);
        }, this.timeToUnblockLoading);
    },
    beforeDestroy() {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
        }
    },
};
</script>

<style src="./LoadingComponent.scss" lang="scss"></style>